import { get, groupBy, map, find, filter, maxBy, size, some } from 'lodash-es';

import { getDataOffer } from './calculateDataOffer';
import { getTitlePart } from './utils';

/**
 *  get questionnaire from salesRoute by ID
 * @param {*} salesRoute
 * @param {*} idQuestionnaire
 */
const getQuestionnaireFromSalesRouteById = (salesRoute, idQuestionnaire) =>
  find(get(salesRoute, 'questionnaires'), item => get(item, 'questionnaire.id') === idQuestionnaire);

/**
 * get part from questionnaire salesRoute by ID
 * @param {*} questionnaire
 * @param {*} idPart
 */
const getPartFromQuestionnaireSalesRouteById = (questionnaire, idPart) =>
  find(get(questionnaire, 'parts'), item => get(item, 'id') === idPart);

const getStrings = strings => ({
  labelButton: 'Choisir cette offre',
  recommendation: 'Nous vous recommandons',
  ...strings,
});

/**
 * check mandatory podium
 * @param {*} param0
 */
const checkMandatory = ({ questionnaire, idPart }) => {
  try {
    const parts = questionnaire?.parts;
    const mandatory = get(find(parts, { id: idPart }), 'mandatory');

    if (typeof mandatory !== 'boolean') {
      // eslint-disable-next-line no-console
      console.error(`checkMandatory: Error Podium, mandatory type is not defined`);
      return undefined;
    }

    return mandatory;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`checkMandatory ${e.stack}`);
  }
  return undefined;
};

/**
 * get Formula Selected Podium
 * @param {*} param0
 */
const getFormulaSelected = ({ contracts, codeCommercialProduct, partyRef }) => {
  try {
    const contract = filter(contracts, c => {
      const hasCovered = partyRef ? some(c.covereds, cov => cov?.party?.ref === partyRef) : true;
      return c?.commercial_product?.code === codeCommercialProduct && hasCovered;
    })[0];

    // Get package from contract root
    let codePackage = get(contract, 'package.code', '');

    if (!codePackage) {
      // Or per covered if option if activated
      codePackage = get(contract, 'covereds[0].package.code', '');
    }

    return codePackage;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getFormulaSelected ${e.stack}`);
  }
  return undefined;
};

/**
 * offers block is ready
 * @param {*} param0
 */
const offersBlockIsReady = ({ salesRoute, questionnaires, products }) => {
  try {
    const isReady =
      size(get(salesRoute, 'quotations[0].offer[0]')) > 0 && size(questionnaires) > 0 && size(products) > 0;
    return isReady;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`quotationBlockIsReady ${e.stack}`);
  }
  return false;
};

/**
 * get podium transform
 * @param {*} salesRoute
 * @param {*} questionnaires
 * @param {*} products
 */
const offersBlockTransform = ({ salesRoute, questionnaires, products, strings = {} }) => {
  try {
    const isReady = offersBlockIsReady({ salesRoute, questionnaires, products });

    if (!isReady) {
      return {};
    }

    // build podiums by questionnaires salesRoute
    const blockOffers = {
      questionnaires: map(get(salesRoute, 'questionnaires'), itemQuestionnaire => {
        const idQuestionnaire = get(itemQuestionnaire, 'questionnaire.id');
        return {
          id: idQuestionnaire,
          parts: map(get(itemQuestionnaire, 'parts'), itemPart => {
            // get
            const idPart = get(itemPart, 'id');
            const questionnaireSR = getQuestionnaireFromSalesRouteById(salesRoute, idQuestionnaire);
            const part = getPartFromQuestionnaireSalesRouteById(questionnaireSR, idPart);
            const packageEligible = filter(get(part, 'results'), { eligible: true });
            const codeProduct = get(
              maxBy(packageEligible, item => get(item, 'score')),
              'product'
            );
            const questionnaire = find(questionnaires, { id: idQuestionnaire });
            const product = find(products, { code: codeProduct });
            const codeCommercialProduct = get(product, 'commercial_products[0].code');
            const codeQuestionnaire = questionnaire?.code;
            const contracts = get(salesRoute, 'contracts');
            const parties = get(salesRoute, 'parties', []);
            const quotation = get(salesRoute, 'quotations[0]');
            const loans = get(salesRoute, 'loans');
            // if the product kind is a loan insurance
            const isLoanKind = product.hasOwnProperty('loan_configuration');

            let covGrouped = { 0: quotation.offer };

            if (questionnaireSR?.description?.options?.contract === 'split_per_covered') {
              covGrouped = groupBy(quotation.offer, ofr => ofr.covereds[0].party.ref);
            }

            return map(covGrouped, (covOffer, idx) => {
              const titlePart = getTitlePart(questionnaire, idPart, isLoanKind, idx, parties, strings);
              get(find(questionnaire?.parts, { id: idPart }), 'title');
              // get mandatory
              const mandatory = checkMandatory({ questionnaire, idPart });
              // get formulaSelected
              const formulaSelected = getFormulaSelected({
                contracts,
                codeCommercialProduct,
                partyRef: idx !== '0' ? idx : null,
              });
              // get dataOffer
              const dataOffer = getDataOffer({
                codeQuestionnaire,
                parties,
                quotation: { ...quotation, offer: covOffer },
                product,
                titlePart,
                part,
                packageEligible,
                codeCommercialProduct,
                strings: getStrings(strings),
                loans,
              });
              // build offer
              const offer = {
                mandatory,
                formulaSelected,
                dataOffer,
                strings: getStrings(strings),
              };

              const result = {
                id: `${idPart}_${idx}`,
                offer,
              };
              return result;
            });
          }).flat(),
        };
      }),
    };

    return blockOffers;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return {};
};

export default offersBlockTransform;
